<template>
  <button
    class="cta-button"
    :class="{ 'cta-button--disabled': disabled, 'cta-button--loading': loading, 'cta-button--with-icon': icon }"
    :disabled="disabled || loading"
    @click="$emit('click')"
  >
    <span v-if="loading" class="cta-spinner"></span>
    <template v-else>
      <img v-if="icon" class="cta-icon" :src="icon" alt="" />
      <span class="cta-text">{{ text }}</span>
    </template>
  </button>
</template>

<script>
export default {
  name: 'CtaButton',
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.cta-button {
  width: 100%;
  height: 67px;
  background: #4868ff;
  border: none;
  border-radius: 16px;
  box-shadow: 0px 4px 13.1px rgba(0, 0, 0, 0.19);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease, transform 0.15s ease;

  &:active:not(:disabled) {
    transform: scale(0.97);
  }

  &--disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &--loading {
    cursor: wait;
  }
}

.cta-button--with-icon {
  // Text + icon are a group, centered together in the button. They sit
  // next to each other with a small gap rather than pushed to opposite
  // edges.
  justify-content: center;
  gap: 16px;
}

.cta-text {
  font-family: 'SimplerPro', sans-serif;
  font-size: 20px;
  line-height: 26px;
  font-weight: 700;
  color: #fff;
}

.cta-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: block;
}

.cta-spinner {
  width: 24px;
  height: 24px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
